<pagination [boundaryLinks]="true" [totalItems]="77"
            previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;">

</pagination>
